import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <>
            {isVisible && (
                <div className='fixed largePhone:bottom-10 smallPhone:bottom-8 largePhone:right-10 smallPhone:right-4 z-30 flex justify-center items-center flex-col'>
                    <div className='smallPhone:w-10 smallPhone:h-10 bg-primary smallPhone:text-base text-white rounded-full flex justify-center items-center cursor-pointer transition ease-in-out delay-150 hover:bg-[#19a095]' onClick={scrollToTop}>
                        <i className="fa-solid fa-circle-arrow-up"></i>
                    </div>
                    <span className='mediumTablet:inline-block smallPhone:hidden text-font_two font-semibold text-sm mt-1'>Scroll To Top</span>
                </div>
            )}
        </>
    );
};

export default ScrollToTopButton;
